import { BaseType } from '../base/base-type';
import { TaxCraLetterOfAuthorityTypeIdEnum } from './tax-cra-letter-of-authority-type-id.enum';

export class TaxCraLetterOfAuthorityType extends BaseType {
  public declare id: TaxCraLetterOfAuthorityTypeIdEnum;
}
